import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getExternalPurchaseById(externalPurchaseId, language, timeZone) {
  try {
    const data = await wsRequestGet(
      `/admin/externalpurchase/${externalPurchaseId}`,
      language,
      timeZone,
    );

    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the external purchase by id ${externalPurchaseId}: ${e}`);
    return {
      success: false,
    };
  }
}
